import { Util, Request } from "@xt/xtbase";
const { getOrigin } = Util;
const { XtAxios4 } = Request;

/** 前台法币兑换：与 convert 前端对接手册一致，网关前缀 /sapi/v4/payment/ */
const URL = getOrigin("www") + "/sapi/v4/payment/";

/**
 * 查询可用转换配置列表（可选择的法币、加密货币、金额范围、汇率等）
 * GET /convert/config/list
 */
export function get_convertConfigList(config) {
  return XtAxios4.get(URL + "convert/config/list", config);
}

/**
 * 转换预览（试算），不产生订单
 * POST /convert/preview
 * @param {Object} payload - { currencyId, cryptoCurrencyId, type: 1|2|3|4|5|6|7, sourceAmount }
 * v2.5：currencyId=from，cryptoCurrencyId=to，type 为 convertType 1–7
 */
export function post_convertPreview(payload, config) {
  return XtAxios4.post(URL + "convert/preview", payload, {
    autoErrorModal: false,
    ...config,
  });
}

/**
 * v2.5 通用下单（推荐）
 * POST /convert/order
 * @param {Object} payload - { fromCurrencyId, toCurrencyId, sourceAmount }
 */
export function post_convertOrder(payload, config) {
  return XtAxios4.post(URL + "convert/order", payload, config);
}

/**
 * 查询转换订单列表
 * GET /convert/order/list
 * @param {Object} params - { type?: 1|2|3|4|5|6|7, ... }
 */
export function get_convertOrderList(params, config) {
  return XtAxios4.get(URL + "convert/order/list", { params, ...config });
}

/**
 * 查询转换订单详情
 * GET /convert/order/{orderId}
 */
export function get_convertOrderDetail(orderId, config) {
  return XtAxios4.get(URL + "convert/order/" + orderId, config);
}
